import IconBase, { type IconProps } from '../IconBase';
const Svg24X24CloseOutline = (props: Omit<IconProps, 'children'>) => {
  return (
    <IconBase data-testid="closeOutline" viewBox="0 0 24 24" {...props} width="24" height="24">
      <>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="m13.414 12 4.95-4.95a1 1 0 0 0-1.414-1.414L12 10.586l-4.95-4.95A1 1 0 0 0 5.636 7.05l4.95 4.95-4.95 4.95a1 1 0 0 0 1.414 1.414l4.95-4.95 4.95 4.95a1 1 0 0 0 1.414-1.414z"
          clipRule="evenodd"
        />
      </>
    </IconBase>
  );
};
export default Svg24X24CloseOutline;
